<!--
    Styles
-->

<style>


    /* main */

    #dashboard aside {
        width: 512px;
        border-left: 1px solid var(--cl-gray);
    }
    #dashboard aside .container {
        position: relative;
        overflow: auto;
    }


    /* tabs */

    #dashboard aside .tabs {
        border-bottom: 1px solid var(--cl-gray);
    }
    #dashboard aside .tabs a {
        line-height: 50px;
        text-align: center;
    }
    #dashboard aside .tabs a:before {
        display: none;
        background: var(--cl-blue);
    }
    #dashboard aside .tabs a.active {
        background: var(--cl-blue);
        color: var(--cl-white);
    }
    #dashboard aside .tabs a.active:before {
        display: block;
    }


    /* sort */

    #dashboard aside .sort {
        position: relative;
        border-bottom: 1px solid var(--cl-gray);
        z-index: 1;
    }
    #dashboard aside .sort .u-flex {
        padding: 0 10px;
    }
    #dashboard aside .sort .ui-select {
        width: 150px;
        height: 50px;
        padding: 0 10px;
        border-left: 1px solid var(--cl-gray);
    }
    #dashboard aside .sort .ui-options {
        border-right: none;
    }
    #dashboard aside .sort .ui-loader {
        top: 100%;
    }


    /* buildings */

    #dashboard aside .buildings {
        padding-bottom: 12px;
    }
    #dashboard aside .buildings .building {
        padding: 12px;
    }
    #dashboard aside .buildings .ui-spinner {
        width: 32px;
        height: 32px;
        margin: 0 auto;
    }


    /* charts */

    #dashboard aside .charts {
        padding: 0 16px;
    }
    #dashboard aside .charts .chart {
        height: 50%;
        min-height: 320px;
        padding: 16px 0;
    }
    #dashboard aside .charts .chart:first-child {
        padding-bottom: 0;
    }
    #dashboard aside .charts .chart > * {
        margin-bottom: 8px;
    }
    #dashboard aside .charts .chart > *:last-child {
        margin-bottom: 0;
    }
    #dashboard aside .charts .chart > .u-flex {
        min-height: 0;
    }


</style>



<!--
    Template
-->

<template>
    <aside class="u-col">


        <!-- tabs -->

        <div class="tabs u-row">
            <a class="u-flex t15 w6 arrow-bottom" :class="{active: tab === 'deals'}" @click="tab = 'deals'">事例検索結果</a>
            <a class="u-flex t15 w6 arrow-bottom" :class="{active: tab === 'charts'}" @click="tab = 'charts'">エリアレポート</a>
        </div>


        <!-- sort -->

        <div class="sort u-row" v-show="tab === 'deals'">
            <ui-loader v-show="pending('sort')" />
            <p class="u-flex">現在、{{ deals.dealsCount }}件の成約取引が該当</p>
            <ui-dropdown v-slot="{active, toggle}">
                <ui-select :label="label" @click.native="toggle" />
                <ui-options v-show="active" :options="sorts" @update="sort" />
            </ui-dropdown>
        </div>


        <!-- buildings -->

        <div class="container buildings u-flex" v-show="tab === 'deals'" ref="deals" @scroll="scroll">
            <item-building class="building t13" v-for="building in buildings" :key="building.id" :building="building" />
            <ui-spinner ref="spinner" v-show="buildings.length && !dealsLoaded" />
            <div class="u-center cl-gray t16" v-show="!pending('sort') && !pending('refresh') && !buildings.length">物件が見つかりません</div>
        </div>


        <!-- charts -->

        <div class="container charts u-flex" v-show="tab === 'charts'">

            <div class="chart u-col" v-if="chartPrices">
                <p class="t20 w6">価格推移</p>
                <aside-prices :data="chartPrices" />
                <chart-prices class="u-flex" :data="chartPrices" />
            </div>

            <div class="chart u-col" v-if="chartDeals">
                <p class="t20 w6">成約件数推移</p>
                <chart-deals class="u-flex" :data="chartDeals" />
            </div>

            <div class="u-center cl-gray t16" v-show="!pending('refresh') && !chartPrices && !chartDeals">データが見つかりません</div>

        </div>


    </aside>
</template>



<!--
    Scripts
-->

<script>


    import {mapGetters, mapState, mapActions} from 'vuex'
    import * as enums from '@/common/helpers/enums'
    import uiDropdown from '@/components/shared/ui/dropdown.vue'
    import uiSelect from '@/components/shared/ui/select.vue'
    import uiOptions from '@/components/shared/ui/options.vue'
    import uiLoader from '@/components/shared/ui/loader.vue'
    import uiSpinner from '@/components/shared/ui/spinner.vue'
    import itemBuilding from '@/components/dashboard/items/building.vue'
    import chartPrices from '@/components/shared/charts/prices.vue'
    import chartDeals from '@/components/shared/charts/deals.vue'
    import asidePrices from './aside.prices.vue'


    // enums

    const serialize = args => args.join(':');
    const sorts = enums.create({
        '価格が低い順': ['minDealPrice', 'asc'],
        '価格が高い順': ['maxDealPrice', 'desc'],
        '広さが小さい順': ['minSqm', 'asc'],
        '広さが大きい順': ['maxSqm', 'desc'],
        '築年が新しい順': ['builtAt', 'desc'],
        '築年が古い順': ['builtAt', 'asc'],
        '成約が新しい順': ['maxDealtAt', 'desc'],
        '成約が古い順': ['minDealtAt', 'asc']
    }, serialize);


    export default {

        components: {
            uiDropdown,
            uiSelect,
            uiOptions,
            uiLoader,
            uiSpinner,
            itemBuilding,
            chartPrices,
            chartDeals,
            asidePrices
        },

        computed: {

            ...mapState('search', [
                'params'
            ]),

            ...mapGetters('dashboard', [
                'deals',
                'buildings',
                'pending',
                'dealsLoaded',
                'chartPrices',
                'chartDeals'
            ]),

            label () {
                return this.params.sort && sorts[serialize(this.params.sort)]
                    || '価格が低い順';
            }

        },

        data () {
            return {
                tab: 'charts',
                sorts
            }
        },

        methods: {

            ...mapActions('dashboard', [
                'more'
            ]),

            sort (key) {
                this.$router.push({
                    name: this.$route.name,
                    query: {
                        ...this.$route.query,
                        sort: this.sorts[key]
                    }
                });
            },

            scroll () {
                const top = this.$refs.spinner.$el.offsetTop;
                if (!top) return; // spinner is hidden
                if (this.$refs.deals.scrollTop + this.$refs.deals.offsetHeight < top) return;
                this.more();
            }

        },

        watch: {

            'deals' (deals) {
                !deals.startIndex && (this.$refs.deals.scrollTop = 0);
            }

        }

    }

</script>

